import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Dotdotdot } from '@hivebrite/design-system/Dotdotdot';

import { MEDIA_CENTER_COVER_SIZE } from 'hb-react/backoffice/apps/MediaCenter/constants';

const FolderThumbnailContent = ({ url, name }) => (
  <WrapperContent>
    {url ? (
      <ImageCover src={url} alt={name} data-testid="folder-image-cover" />
    ) : (
      <NoImageCover>
        <Dotdotdot clamp={3}>{name}</Dotdotdot>
      </NoImageCover>
    )}
  </WrapperContent>
);

FolderThumbnailContent.propTypes = {
  name: PropTypes.string.isRequired,
  url: PropTypes.string,
};

export default FolderThumbnailContent;

const WrapperContent = styled(Box).attrs(() => ({
  justifyContent: 'center',
  width: '100%',
}))`
  aspect-ratio: ${() => MEDIA_CENTER_COVER_SIZE.aspectRatio};
`;

const ImageCover = styled(Box)
  .withConfig({
    shouldForwardProp: (prop) => !['src'].includes(prop),
  })
  .attrs(() => ({
    justifyContent: 'center',
    width: '100%',
  }))`
  background-image: ${({ src }) => `url(${src})`};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
`;

const NoImageCover = styled(Box).attrs(() => ({
  font: 'h2-regular',
  fontSize: 5,
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  p: 5,
}))`
  border-top: 1px solid;
  border-bottom: 1px solid;
  border-color: ${({ theme }) => theme.colors.cloud};
`;
